import Vue from 'vue'
import Login from '../components/Login.vue'
import Index from '../components/Index.vue'
import Content from '../components/views/Content.vue'
import Main from '../components/Main.vue'
import MenuTree from '../components/views/menu/MenuTree.vue'
import menuEdit from '../components/views/menu/MenuEdit.vue'
import changePwd from '../components/ChangePwd.vue'
/*活动管理*/
import ActivityManager from '../components/views/activity/ActivityManager.vue'
/*创建活动*/
import CreateActivity from '../components/views/activity/CreateActivity.vue'
/*活动基础信息*/
import ActBase from '../components/views/activity/ActBase.vue'
/*选择应用*/
import ChoiceApp from '../components/views/activity/ChoiceApp.vue'
/*选择参与条件*/
import ChoiceCondition from '../components/views/activity/ChoiceCondition.vue'
/*选择售货机*/
import ChoiceDevice from '../components/views/activity/ChoiceDevice.vue'
/*转盘配置页面*/
import WheelFragment from '../components/views/activity/WheelFragment.vue'
/*派样配置页面*/
import SamplingFragment from '../components/views/activity/SamplingFragment.vue'
/*测试时图表*/
import EchartsTest from '../components/views/activity/EchartsTest.vue'

import png from '../components/views/png.vue'
/*商品*/
import productMananger from '../components/views/product/productMananger.vue'
import productModify from '../components/views/product/productModify.vue'
import pro from '../components/views/product/pro.vue'
import editPro from '../components/views/product/editPro.vue'
import cate from '../components/views/product/Cate.vue'

/*用户*/
import  userManager from '../components/views/user/UserManager.vue'
import  roleManager from '../components/views/user/RoleManager.vue'
import  configRoles from '../components/views/user/ConfigRoles.vue'
import  configUser from '../components/views/user/ConfigUser.vue'
import  configResource from '../components/views/user/ConfigResource.vue'
import  configAuthority from '../components/views/user/ConfigAuthority.vue'
import  tenantManager from '../components/views/user/TenantManager.vue'

/*客服*/
import  appletOrderManager from '../components/views/order/appletOrderManager.vue'
import  orderRef from '../components/views/order/orderRef.vue'
import  trade from '../components/views/order/trade.vue'
import  orderInfo from '../components/views/order/orderInfo.vue'




// 统计
import appletSaleCount from '../components/views/chart/appletSaleCount.vue'

//提货码
import ExcodeManager from '../components/views/excode/ExcodeManager.vue'
import ExcodeAdd from '../components/views/excode/ExcodeAdd.vue'
import ExcodeModify from '../components/views/excode/ExcodeModify.vue'

//商品分组
import groupManager from '../components/views/group/groupManager.vue'
import groupAdd from '../components/views/group/groupAdd.vue'
import groupModify from '../components/views/group/groupModify.vue'

//微页面
import homePageManager from '../components/views/homePage/homePageManager.vue'
import addHomePage from '../components/views/homePage/addHomePage.vue'
import modifyHomePage from '../components/views/homePage/modifyHomePage.vue'

/*日志*/
import logManager from '../components/views/Log/LogManager.vue'

/*素材*/
import materialManager from '../components/views/material/MaterialManager.vue'
import materialAdd from '../components/views/material/MaterialAdd.vue'
import materialEdit from '../components/views/material/MaterialEdit.vue'
import wclogin from '../components/wcLogin.vue'
/*组织机构*/
import orgManager from '../components/views/org/OrgManager.vue'
import orgAdd from '../components/views/org/OrgAdd.vue'
import orgModify from '../components/views/org/OrgModify.vue'
import orgUser from '../components/views/org/OrgUser.vue'

/**设备**/
import deviceManager from '../components/views/device/deviceManager.vue'
import addDevice from '../components/views/device/addDevice.vue'
import modifyDevice from '../components/views/device/modifyDevice.vue'

/**广告**/
import advertiseManager from '../components/views/market/AdvertiseManager.vue'
import advertiseAdd from '../components/views/market/AdvertiseAdd.vue'
import AdvertiseModify from '../components/views/market/AdvertiseModify.vue'
import AdPush from '../components/views/market/AdPush.vue'

const routes = [
    {path: '/login',name: 'login', component: Login},
    {path: '/wclogin/:wcUserId/:timestamp/:sign',name: 'wclogin', component: wclogin},
    /*{path: '/ceshi',name: 'ceshi', component: ceshi},*/
    {path:'/png',name:'png',component:png},
    {path: '/changePwd',name: 'changePwd', component: changePwd},
    {
        path: '/main',name: 'main', component: Main,
        children: [
            {path: '', component: Index},
            {path: '/index',name: 'index', component: Index},
            {
                path: '/content/02', name: 'content02',component: Content,
                children: [
                    // {path: 'kioskSaleManager', name:'kioskSaleManager', component: kioskSaleManager},
                    {path: 'appletSaleCount', name:'appletSaleCount', component: appletSaleCount},
                    {path: 'appletOrderManager', name: 'appletOrderManager', component: appletOrderManager},
                    {path: 'orderRef', name: 'orderRef', component: orderRef},
                    {path: 'trade', name: 'trade', component: trade},
                    {path: 'orderInfo', name: 'orderInfo', component: orderInfo},
                    {path: 'productMananger', name: 'productMananger', component: productMananger},
                    {path: 'productModify', name: 'productModify', component: productModify},
                    {path: 'pro', name: 'pro', component: pro},
                    {path: 'editPro', name: 'editPro', component: editPro},
                    {path: 'cate', name: 'cate', component: cate},
                    {path: 'menu',name: 'menu', component: MenuTree},
                    {path: 'menuEdit/:id',name: 'menuEdit',component: menuEdit},
                    /*后台用户*/
                    {path: 'userManager', name: 'userManager', component: userManager},
                    {path: 'roleManager', name: 'roleManager', component: roleManager},
                    {path: 'configRoles/:userId', name: 'configRoles', component: configRoles},
                    {path: 'configUser/:storeId', name: 'configUser', component: configUser},
                    {path: 'configResource/:roleId', name: 'configResource', component: configResource},
                    {path: 'tenantManager', name: 'tenantManager', component: tenantManager},
                    {path: 'configAuthority/:roleId', name:'configAuthority',component:configAuthority},
                    {path: 'logManager', name:'logManager',component:logManager},
                    {path: 'ExcodeManager', name:'ExcodeManager',component:ExcodeManager},
                    {path: 'ExcodeModify', name:'ExcodeModify',component:ExcodeModify},
                    {path: 'ExcodeAdd', name:'ExcodeAdd',component:ExcodeAdd},
                    {path: 'groupManager', name:'groupManager',component:groupManager},
                    {path: 'groupAdd', name:'groupAdd',component:groupAdd},
                    {path: 'groupModify', name:'groupModify',component:groupModify},
                    {path: 'ActivityManager', name:'ActivityManager',component:ActivityManager},
                    {path: 'CreateActivity', name:'CreateActivity',component:CreateActivity},
                    {path: 'ActBase', name:'ActBase',component:ActBase},
                    {path: 'ChoiceApp', name:'ChoiceApp',component:ChoiceApp},
                    {path: 'ChoiceCondition', name:'ChoiceCondition',component:ChoiceCondition},
                    {path: 'ChoiceDevice', name:'ChoiceDevice',component:ChoiceDevice},
                    {path: 'WheelFragment', name:'WheelFragment',component:WheelFragment},
                    {path: 'SamplingFragment', name:'SamplingFragment',component:SamplingFragment},
                    {path: 'homePageManager', name:'homePageManager', component: homePageManager},
                    {path: 'addHomePage', name:'addHomePage', component: addHomePage},
                    {path: 'modifyHomePage', name:'modifyHomePage', component: modifyHomePage},
                    {path: 'materialManager', name:'materialManager',component:materialManager},
                    {path: 'materialAdd', name:'materialAdd',component:materialAdd},
                    {path: 'materialEdit/:resourcesId', name:'materialEdit',component:materialEdit},
                    {path: 'orgManager', name:'orgManager',component:orgManager},
                    {path: 'orgAdd', name:'orgAdd',component:orgAdd},
                    {path: 'orgModify', name:'orgModify',component:orgModify},
                    {path: 'orgUser', name:'orgUser',component:orgUser},
                    {path: 'deviceManager', name:'deviceManager', component: deviceManager},
                    {path: 'addDevice', name:'addDevice', component: addDevice},
                    {path: 'modifyDevice', name:'modifyDevice', component: modifyDevice},
                    {path: 'EchartsTest', name:'EchartsTest', component: EchartsTest},
                    {path: 'advertiseManager', name:'advertiseManager', component: advertiseManager},
                    {path: 'advertiseAdd', name:'advertiseAdd', component: advertiseAdd},
                    {path: 'AdvertiseModify', name:'AdvertiseModify', component: AdvertiseModify},
                    {path: 'AdPush', name:'AdPush', component: AdPush},
                ]
            }
        ]
    },
    {path: '*', redirect: '/login'}
]

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js